import React from 'react'
import { type LucideProps } from 'lucide-react'

const BridgeAct: React.FC<LucideProps> = (props: LucideProps) => (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<circle cx="14.8468" cy="8.04857" r="0.324812" stroke="white" stroke-width="0.5"/>
<circle cx="14.4936" cy="8.04852" r="1.15655" stroke="white" stroke-width="0.5"/>
<circle cx="13.4998" cy="8.04871" r="2.15027" stroke="white" stroke-width="0.5"/>
<circle cx="12.4576" cy="7.92913" r="3.19256" stroke="white" stroke-width="0.5"/>
<circle cx="11.3852" cy="7.92914" r="4.26496" stroke="white" stroke-width="0.5"/>
<circle cx="10.0415" cy="7.92917" r="5.60862" stroke="white" stroke-width="0.5"/>
<circle cx="8.4001" cy="7.9292" r="7.25" stroke="white" stroke-width="0.5"/>
</svg>


)

export default BridgeAct
